import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerInterface } from '../../models/customer.interface';
import { AddressInterface } from '../../models/address.interface';
import { select, Store } from '@ngrx/store';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { AddressInterfaceState } from '../../store/state/address.state';
import { GetAddress, SetPrincipalAddress } from '../../store/actions/address.actions';
import { CustomerInterfaceState } from '../../store/state/customer.state';
import { CheckPasswordInterfaceState } from '../../../shared/store/state/check-password.state';
import { UpdateCheckPasswordVisibility } from '../../../shared/store/actions/check-password.actions';
import { CheckPasswordInterface } from '../../../shared/models/check-password.interface';
import { ExtranetService } from '../../../shared/services/extranet.service';

@Component({
    selector: 'app-address-list',
    templateUrl: './address-list.component.html',
    styleUrls: ['./address-list.component.css'],
    standalone: false
})
export class AddressListComponent implements OnInit {

  customer: CustomerInterface = null;
  shippingAddress: Array<AddressInterface> = [];
  passwordResponse: CheckPasswordInterface;

  constructor(
      private router: Router,
      private store: Store<any>,
      private extranetService: ExtranetService
  ) {}

  ngOnInit() {
    this.store.pipe(select(ConstsHelper.REDUCER_ADDRESS)).subscribe( (result: AddressInterfaceState) => {
      if (null != result.address) {
        this.shippingAddress = result.address.sort(
            (adr1, adr2) => (adr1.id > adr2.id) ? 1 : (adr1.id < adr2.id) ? -1 : 0);
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_CUSTOMER)).subscribe( (result: CustomerInterfaceState) => {
      if (null != result.customer) {
        this.customer = result.customer;
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_CHECK_PASSWORD)).subscribe((response: CheckPasswordInterfaceState) => {
      if (response.result != null && (['adresse-facturation', 'adresse-livraison', 'selected-shipping-address', 'delete-shipping-address', 'add-shipping-address'].indexOf(response.result.page) !== -1)) {
        this.passwordResponse = response.result;
        if (this.passwordResponse.isValid === true) {
          if (this.passwordResponse.page === 'adresse-facturation') {
            this.router.navigate(['/compte/adresses/modifier/adresse-facturation']);
          } else if (this.passwordResponse.page === 'adresse-livraison') {
            this.router.navigate(['/compte/adresses/modifier/adresse-livraison']);
          } else if (this.passwordResponse.page === 'delete-shipping-address') {
            this.router.navigate(['/compte/adresses/supprimer/adresse-livraison']);
          } else if (this.passwordResponse.page === 'add-shipping-address') {
            this.router.navigate(['/compte/adresses/ajouter/adresse-livraison']);
          } else {
            this.store.dispatch(new SetPrincipalAddress(this.passwordResponse.object.id, true, this.passwordResponse.password));
          }
        }
      } else if (response.result !== null && response.result.visibility === false && response.result.password === null) {
        this.store.dispatch(new GetAddress());
      }
    });

    this.store.dispatch(new GetAddress());
  }

  displayPasswordModal() {
    if (this.extranetService.getSupportUser()) {
      this.store.dispatch(new UpdateCheckPasswordVisibility({visibility: false, isValid: true, password: null, page: 'adresse-facturation', object: this.customer}));
    } else {
      this.store.dispatch(new UpdateCheckPasswordVisibility({visibility: true, isValid: null, password: null, page: 'adresse-facturation', object: this.customer}));
    }
  }
}
